module.exports = __webpack_public_path__ + "img/ytbdsh@3x.fd762f92.png";